import { env } from '@/config/env-schema'
import config from '-/config/brand'

export type KeycloakConf = {
  url: string
  realm: string
  clientId: string
}

export type BrazeConf = {
  apiKey: string
  baseUrl: string
}

export type BrandFeatures = {
  isSweepsCoinsEnabled: boolean
  isHeroBannerEnabled: boolean
}

export interface AmplitudeConfig {
  apiKey: string
  loggingEnabled: boolean
  region: string
  deploymentKey: string
}

export type EnabledGrafanaConfig = {
  isEnabled: true
  url: string
  appName: 'Vanilla' | 'Unitedslots'
}

export type DisabledGrafanaConfig = {
  isEnabled: false
  url?: undefined
  appName?: undefined
}

export type GrafanaConfig = EnabledGrafanaConfig | DisabledGrafanaConfig

export type Config = {
  name: string
  code: string
  gamGalleryViewApiUrl: string
  gamGalleryUserPreferencesApiUrl: string
  gamQuestsPlayerApiUrl: string
  gamGalleryTickersApiUrl: string
  pamPlayerTokensApiUrl: string
  pamStoreApiUrl: string
  pamAccountApiUrl: string
  pamAmoeApiUrl: string
  pamPlayerTokensHistoryApiUrl: string
  pamRedemptionApiUrl: string
  gamPeriodicBonusServiceApiUrl: string
  pamPurchaseLimitsApiUrl: string
  pamKycApiUrl: string
  gamGameRoundInfoApiUrl: string
  pamRsgApiUrl: string
  payPurchasesApiUrl: string
  payRedemptionsApiUrl: string
  heroBannerType: Record<
    string,
    'carouselBasic' | 'carouselOverlayed' | 'carouselWithLeadingCard' | 'simple'
  >
  keycloak: KeycloakConf
  braze: BrazeConf
  features: Omit<BrandFeatures, 'isSweepsCoinsEnabled'>
  amplitude: AmplitudeConfig
  helpCenterUrl: string
  postalRequestMoreInfoUrl: string
  pamLegalDocumentsUrl: string
  ageRestriction: number
  logo: { width: number; height: number; src: string }
  brandedAnimation: unknown
  grafana: GrafanaConfig
  minimumRedemptionThreshold: string
}

export type PerEnvironmentConfigs = {
  [K in typeof env.CLIENT_VAR__APP_ENV]: Config
}

export const getBrandConfig = (): Config => {
  return config[env.CLIENT_VAR__APP_ENV]
}
